import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

/**
 * Hiển thị thông báo toast chung
 * @param {Object} vm - Vue instance
 * @param {Object} options - Tùy chọn thông báo
 * @param {string} options.title - Tiêu đề thông báo
 * @param {string} options.icon - Icon (mặc định: 'InfoIcon')
 * @param {string} options.variant - Loại thông báo (mặc định: 'info')
 * @param {string} options.text - Nội dung bổ sung
 * @param {string} options.position - Vị trí hiển thị (mặc định: 'top-right')
 */
export const showToast = (vm, {
  title,
  icon = 'InfoIcon',
  variant = 'info',
  text = '',
  position = 'top-right',
}) => {
  vm.$toast({
    component: ToastificationContent,
    position,
    props: {
      title,
      icon,
      variant,
      text,
    },
  })
}

/**
 * Hiển thị thông báo lỗi
 * @param {Object} vm - Vue instance
 * @param {Object|string} error - Lỗi hoặc message
 * @param {string} defaultMessage - Message mặc định
 */
export const showErrorToast = (vm, error, defaultMessage = 'Đã xảy ra lỗi') => {
  let message = defaultMessage

  if (typeof error === 'string') {
    message = error
  } else if (error?.message) {
    message = error.code ? `[${error.code}] ${error.message}` : error.message
  }

  showToast(vm, {
    title: message,
    icon: 'XCircleIcon',
    variant: 'danger',
  })
}

/**
 * Hiển thị thông báo thành công
 * @param {Object} vm - Vue instance
 * @param {string} message - Nội dung thông báo
 */
export const showSuccessToast = (vm, messageOrOptions) => {
  const isStringMessage = typeof messageOrOptions === 'string'
  const title = isStringMessage ? messageOrOptions : messageOrOptions?.title
  const text = isStringMessage ? '' : (messageOrOptions?.text || '')
  const position = isStringMessage ? undefined : messageOrOptions?.position

  showToast(vm, {
    title,
    icon: 'CheckIcon',
    variant: 'success',
    text,
    position,
  })
}

/**
 * Hiển thị thông báo cảnh báo
 * @param {Object} vm - Vue instance
 * @param {string} message - Nội dung thông báo
 */
export const showWarningToast = (vm, messageOrOptions) => {
  const isStringMessage = typeof messageOrOptions === 'string'
  const title = isStringMessage ? messageOrOptions : messageOrOptions?.title
  const text = isStringMessage ? '' : (messageOrOptions?.text || '')
  const position = isStringMessage ? undefined : messageOrOptions?.position

  showToast(vm, {
    title,
    icon: 'InfoIcon',
    variant: 'warning',
    text,
    position,
  })
}

/**
 * Hiển thị thông báo thông tin
 * @param {Object} vm - Vue instance
 * @param {string} message - Nội dung thông báo
 */
export const showInfoToast = (vm, messageOrOptions) => {
  const isStringMessage = typeof messageOrOptions === 'string'
  const title = isStringMessage ? messageOrOptions : messageOrOptions?.title
  const text = isStringMessage ? '' : (messageOrOptions?.text || '')
  const position = isStringMessage ? undefined : messageOrOptions?.position

  showToast(vm, {
    title,
    icon: 'InfoIcon',
    variant: 'info',
    text,
    position,
  })
}
